/**
 * csv.js - CSV cell rules shared by every export (exportCsv, the chat's table
 * export, the Projects / Opportunities CSVs).
 */

/** Quote a cell iff it holds a comma, quote, CR or LF; inner quotes doubled. */
export const csvCell = (v) => {
  const s = v == null ? '' : String(v);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** A CSV money cell: 2 decimals, blank stays blank. */
export const csvMoney2 = (v) => (v == null || v === '' ? '' : parseFloat(v).toFixed(2));
/** A CSV text cell Excel keeps as typed (leading zeros): ="...", blank stays blank. */
export const csvText = (v) => (v == null || v === '' ? '' : `="${String(v).replace(/"/g, '""')}"`);
